import React from "react";
import Slider from "react-slick";
import "./BannerImg.scss";

const BannerImg = ({ mobileImage, desktopImage }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
        },
      },
    ],
  };
  console.log("mobileSrc",mobileImage);
  return (
    <Slider className="study-slider" {...settings}>
      
      {/* Slide 1 */}
      <div className="favourite-item banner-img-wrapper">
        <img
          loading="lazy"
          className="banner-image mobile"
          src={"https://ggfx-martyngerrard.s3.eu-west-2.amazonaws.com/i.dev/web_banner_ads_2026_1b_e423c0e1bc.jpg"}
          alt="Banner"
        />
        <img
          loading="lazy"
          className="banner-image desktop"
          src={"https://ggfx-martyngerrard.s3.eu-west-2.amazonaws.com/i.dev/web_banner_ads_2026_1a_487f85eebe.jpg"}
          alt="Banner"
        />
      </div>

      {/* Slide 2 */}
      <div className="favourite-item banner-img-wrapper">
        <img
          loading="lazy"
          className="banner-image mobile"
          src={"https://ggfx-martyngerrard.s3.eu-west-2.amazonaws.com/i.dev/web_banner_ads_2026_2b_7b92d00486.jpg"}
          alt="Banner"
        />
        <img
          loading="lazy"
          className="banner-image desktop"
          src={"https://ggfx-martyngerrard.s3.eu-west-2.amazonaws.com/i.dev/web_banner_ads_2026_2a_d33e5713d3.jpg"}
          alt="Banner"
        />
      </div>

    </Slider>
  );
};

export default BannerImg;
